// extracted by mini-css-extract-plugin
export var closeButton = "_y-1";
export var container = "_y-0";
export var fullModalImage = "_y-2";